// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-content[data-v-35bd9e63]{width:-moz-max-content;width:max-content;max-height:50vh;overflow:auto}.button[data-v-35bd9e63]{padding-left:.5rem;padding-right:.5rem}.button .icon[data-v-35bd9e63]:last-child:not(:first-child){margin-left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
